import { BaseOrder } from "./BaseOrder";
import { OrderId } from "./OrderId";
import { OrderResponse } from "./OrderResponse";
import { OrderStatus } from "./OrderStatus";
import { OrderTypes } from "./OrderTypes";
import { Model } from "./Model";
import { DocumentationAreaActorOrderRetrievalMethod } from "./DocumentationAreaActorOrderRetrievalMethod";
import { ExtractionDetails } from "./ExtractionDetails";

export type OrderModelParams = {
  id: OrderId;
  request: Model;
  responses: OrderResponse[];
  retrievalMethods: DocumentationAreaActorOrderRetrievalMethod[];
  status: OrderStatus;
  extractionDetails: ExtractionDetails | null;
};

export type OrderModelCreateParams = {
  id?: OrderId;
  request: Model;
};

export class OrderModel extends BaseOrder<Model> {
  private readonly extractionDetails: ExtractionDetails | null;

  constructor({
    id,
    request,
    responses,
    retrievalMethods,
    status,
    extractionDetails = null,
  }: OrderModelParams) {
    super(id, OrderTypes.MODEL, request, responses, retrievalMethods, status);
    this.extractionDetails = extractionDetails;
  }

  static fromPrimitives(data: any): OrderModel {
    return new OrderModel({
      id: data.id,
      request: data.request,
      responses:
        data.responses?.map(
          (response: any) =>
            new OrderResponse({
              id: response.id,
              createdAt: new Date(response.createdAt),
              inputFiles: response.inputFiles || [],
              outputFiles: response.outputFiles || [],
              status: response.status,
              statusMessages: response.statusMessages || [],
              retrievalMethodOutput: response.retrievalMethodOutput || null,
            }),
        ) || [],
      retrievalMethods:
        data.retrievalMethods?.map(
          (method: any) =>
            new DocumentationAreaActorOrderRetrievalMethod({
              name: method.name,
              config: method.config || null,
            }),
        ) || [],
      status: data.status,
      extractionDetails: data.extractionDetails
        ? {
            status: data.extractionDetails.status,
            reason: data.extractionDetails.reason,
          }
        : null,
    });
  }

  public getExtractionDetails(): ExtractionDetails | null {
    return this.extractionDetails;
  }
}
